import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useCategoriesAndItems} from 'hooks/Product/Product';
import {Icon} from 'shared/helpers';
import {Items} from 'shared/components/Product/Items';
import {RecentItems} from 'shared/components/Product/RecentItems';
import {Alert} from 'react-bootstrap';
import {TitleAndBreadcrumbs} from 'components/customer/Product/TitleAndBreadcrums';
import {Categories} from 'shared/components/Product/Categories';
import {useAppSelector} from 'store/customer';
import {selectSearchText} from 'components/customer/Product/store/productSlice';
import {NoProducts} from 'shared/components/Product/NoProducts';

type CategoriesAndItemsType = {
    isProduct?: boolean;
    is3drp?: boolean;
};

export const CategoriesAndItems = ({
    isProduct = false,
}: CategoriesAndItemsType) => {
    const {loader, categories, items} = useCategoriesAndItems();
    const [errorMessages, setErrorMessages] = useState<string[]>([]);
    const search = useAppSelector(selectSearchText);
    const [searchParams] = useSearchParams();

    return (
        <span>
            {errorMessages.length ? (
                <div className="jobFormErrors" style={{marginTop: '15px'}}>
                    {errorMessages.map((errorMessage) => {
                        return (
                            <Alert variant="danger" key={errorMessage}>
                                <Icon iconName="Button-Error.svg" />
                                <div>{errorMessage}</div>
                            </Alert>
                        );
                    })}
                </div>
            ) : null}
            <TitleAndBreadcrumbs
                categories={categories}
                itemsCount={items ? items.length : 0}
            />

            {search ||
            searchParams.has('favourites') ||
            searchParams.has('products') ? null : (
                <Categories
                    isProduct={isProduct}
                    categories={categories}
                    loader={loader}
                />
            )}

            {search && items && items.length == 0 && !loader ? (
                <NoProducts setError={setErrorMessages} isProduct={isProduct} />
            ) : null}

            {items.length ? (
                <Items
                    items={items}
                    noHr={!categories.length}
                    isProduct={isProduct}
                    setError={setErrorMessages}
                    loader={loader}
                    showScrollButton={
                        !(
                            searchParams.has('products') ||
                            searchParams.has('favourites')
                        )
                    }
                />
            ) : (
                <RecentItems
                    isProduct={isProduct}
                    setError={setErrorMessages}
                />
            )}
        </span>
    );
};
